
import { Check, MessageSquare, Wrench } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { motion } from "framer-motion";

const HowItWorksSection = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section id="how-it-works" className="py-24 px-4 bg-gray-50 dark:bg-gray-800/50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900 dark:text-white">
            How NationCard™ Works
          </h2>

          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our platform makes civic engagement simple, transparent, and
            actionable through three key steps:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <Card className="bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <CardHeader className="text-center pb-2">
              <div className="w-16 h-16 bg-nation-purple/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="h-7 w-7 text-nation-purple" />
              </div>
              <h3 className="font-semibold text-xl text-gray-800 dark:text-white">Verify & Participate</h3>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-muted-foreground leading-relaxed">
                Create your account, verify your identity as a Cayman citizen, and participate in polls on important local issues.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <CardHeader className="text-center pb-2">
              <div className="w-16 h-16 bg-nation-purple/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <MessageSquare className="h-7 w-7 text-nation-purple" />
              </div>
              <h3 className="font-semibold text-xl text-gray-800 dark:text-white">Explore Insights</h3>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-muted-foreground leading-relaxed">
                Access data-driven insights on where Caymanians stand on critical topics and track sentiment changes over time.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 shadow-lg border border-gray-100 dark:border-gray-700 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <CardHeader className="text-center pb-2">
              <div className="w-16 h-16 bg-nation-purple/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Wrench className="h-7 w-7 text-nation-purple" />
              </div>
              <h3 className="font-semibold text-xl text-gray-800 dark:text-white">Drive Change</h3>
            </CardHeader>
            <CardContent className="text-center">
              <p className="text-muted-foreground leading-relaxed">
                Use the platform data to hold elected officials accountable and work together for meaningful community action.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
